import React, { lazy, Suspense } from 'react';
import { fha203kProgramName, foreignNationalProgramName } from '../Utils/WHL/helpers';
import { Loader } from './Loader';

const FHAPage = lazy(() => import('../pages/fha-page/index'));
const VAPage = lazy(() => import('../pages/va-page/index'));
const USDAPage = lazy(() => import('../pages/usda-page/index'));
const ConvPage = lazy(() => import('../pages/conv-page/index'));
const JumboPage = lazy(() => import('../pages/jumbo-page/index'));
const EquoDpaPage = lazy(() => import('../pages/equodpa-page/index'));
const NonQMPage = lazy(() => import('../pages/nonqm-page/index'));
const HECMPage = lazy(() => import('../pages/hecm-page/index'));
const PrimeJumbo = lazy(() => import('../pages/prime-jumbo-page/index'));
const Dscr = lazy(() => import('../pages/dscr-page/index'));
const ForeignNationalPage = lazy(() => import('../pages/foreign-n-page/index'));
const Fha203kPage = lazy(() => import('../pages/fha-203K-page'));
const ChenoaPage = lazy(() => import('../pages/chenoa'));


const WhlPageWrapper = ({
    pageDetails
}) => {

    const { pageName } = pageDetails

    return <>
        {
            pageName === 'FHA' && <>
                <Suspense fallback={<Loader />}>
                    <FHAPage pageDetails={pageDetails} />
                </Suspense>
            </>
        }
        {
            pageName === 'VA' && <>
                <Suspense fallback={<Loader />}>
                    <VAPage pageDetails={pageDetails} />
                </Suspense>
            </>
        }
        {
            pageName === 'USDA' && <>
                <Suspense fallback={<Loader />}>
                    <USDAPage pageDetails={pageDetails} />
                </Suspense>
            </>
        }
        {
            pageName === 'Conventional' && <>
                <Suspense fallback={<Loader />}>
                    <ConvPage pageDetails={pageDetails} />
                </Suspense>
            </>
        }
        {
            pageName === 'HECM' && <>
                <Suspense fallback={<Loader />}>
                    <HECMPage pageDetails={pageDetails} />
                </Suspense>
            </>
        }
        {
            pageName === 'Non QM' && <>
                <Suspense fallback={<Loader />}>
                    <NonQMPage pageDetails={pageDetails} />
                </Suspense>
            </>
        }
        {
            pageName === 'Prime Jumbo' && <>
                <Suspense fallback={<Loader />}>
                    <PrimeJumbo pageDetails={pageDetails} />
                </Suspense>
            </>
        }
        {
            pageName === 'DSCR' && <>
                <Suspense fallback={<Loader />}>
                    <Dscr pageDetails={pageDetails} />
                </Suspense>
            </>
        }
        {
            pageName === foreignNationalProgramName && <>
                <Suspense fallback={<Loader />}>
                    <ForeignNationalPage pageDetails={pageDetails} />
                </Suspense>
            </>
        }
        {
            pageName === fha203kProgramName && <>
                <Suspense fallback={<Loader />}>
                    <Fha203kPage pageDetails={pageDetails} />
                </Suspense>
            </>
        }
        {
            pageName === 'Chenoa DPA' && <>
                <Suspense fallback={<Loader />}>
                    <ChenoaPage pageDetails={pageDetails} />
                </Suspense>
            </>
        }
        {
            pageName === 'Jumbo' && <>
                <Suspense fallback={<Loader />}>
                    <JumboPage pageDetails={pageDetails} />
                </Suspense>
            </>
        }
         {
            pageName === 'EQUO DPA' && <>
                <Suspense fallback={<Loader />}>
                    <EquoDpaPage pageDetails={pageDetails} />
                </Suspense>
            </>
        }
    </>

}

export default WhlPageWrapper;
